import { useState, useEffect } from 'react';
import { getCommissionSourceAnalytics } from '../services/affiliateService';

export interface CommissionSourceAnalytics {
  linkStats: {
    count: number;
    totalEarnings: number;
    totalOrderValue: number;
    avgOrderValue: number;
    avgCommission: number;
  };
  discountStats: {
    count: number;
    totalEarnings: number;
    totalOrderValue: number;
    avgOrderValue: number;
    avgCommission: number;
  };
  summary: {
    totalCommissions: number;
    totalEarnings: number;
    linkPercentage: number;
    discountPercentage: number;
    linkEarningsPercentage: number;
    discountEarningsPercentage: number;
  };
}

export const useCommissionSourceAnalytics = (timePeriod?: string) => {
  const [analytics, setAnalytics] = useState<CommissionSourceAnalytics | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getCommissionSourceAnalytics(timePeriod);
      setAnalytics(data);
    } catch (err) {
      console.error('Error fetching commission source analytics:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch analytics');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, [timePeriod]);

  return {
    analytics,
    loading,
    error,
    refresh: fetchAnalytics
  };
}; 